enum Action {
  FETCH_SHIFT_ROTATIONS = 'fetchShiftRotations',
  CREATE_EMPLOYMENT_ROTATION_GROUP = 'createEmploymentRotationGroup',
  UPDATE_EMPLOYMENT_ROTATION_GROUP = 'updateEmploymentRotationGroup',
}

export default Action;
